module.exports = __webpack_public_path__ + "img/czech-republic.f7c961f5.svg";